import React from "react";

import { faClock } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IonInput } from "@ionic/react";

export default class Time extends React.Component<any, any> {
  render() {
    const { placeholder, ...fieldProps } = this.props;
    return (
      <IonInput placeholder={this.props.attr?.placeholder ? this.props.attr?.placeholder : placeholder} type="time" {...fieldProps}>
        <FontAwesomeIcon icon={faClock} />
      </IonInput>
    );
  }
}
